module.exports = __webpack_public_path__ + "img/sql.7ef81265.svg";